export enum SorterTypes {
  Price = 'PRICE',
  Duration = 'DURATION',
  Recommended = 'RECOMENDATION',
  Category = 'CATEGORY',
  DiscountPercentage = 'DISCOUNTPERCENTAGE',
  Departure = 'DEPARTURE',
  Arrival = 'ARRIVAL',
}
